import { actions, selectors } from 'data'
import { ModalNameType } from 'data/App/types'
import { StateType } from 'data/types'
import { connect, ConnectedProps } from 'react-redux'

import OrderDetails from './template'

type OwnPropsType = {
  readonly modalName?: ModalNameType
}

const mapStateToProps = (state: StateType) => ({
  canTrade: selectors.eligibility.getEligibility(state).trade.enabled,
  order: selectors.historical.getOrderDetails(state),
  precision: selectors.instrument.getPrecision(state),
  screenWidth: selectors.app.getScreenWidth(state),
  userFees: selectors.auth.getUserFees(state)
})

const mapDispatchToProps = (dispatch) => ({
  cancel: (id: string) => {
    dispatch(
      actions.analytics.trackEvent({
        key: 'Trade Cancellation Requested',
        properties: {
          origin: 'TRADE_DETAILS'
        }
      })
    )
    dispatch(actions.order.cancel(id))
    dispatch(actions.app.hideModal('ORDER_DETAILS'))
  },
  hideModal: () => {
    dispatch(actions.app.hideModal('ORDER_DETAILS'))
  }
})

const connector = connect(mapStateToProps, mapDispatchToProps)

export type PropsType = OwnPropsType & ConnectedProps<typeof connector>

export default connector(OrderDetails)
